import React, {useCallback, useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {
	Checkbox,
	Layout,
	Table,
	// Text,
} from '@phonectas/unifon-ui-kit';
import {StyledSectionDiv} from '../../styled';
// import {StyledBnGrid} from '../styled';

interface BedriftsnettData {
    org_nr: string;
    name: string;
    storkunde: string;
    storkunde_ansvarlig: string;
    company_type: string;
    brreg_antall_ansatte: number;
    brreg_naeringkode: string;
    index?: number;
}

interface BedriftsnettTableProps {
    data?: BedriftsnettData[];
	id?: string;
}

interface BedriftsnettService {
	name: string;
	status: boolean;
}

const BedriftsnettTable: React.FC<BedriftsnettTableProps> = ({data, id}) => {
	const [t] = useTranslation();
	console.log('BedriftsnettTable id:', id);

	const services = useMemo(() => [
		{name: 'Office 365 AD sync', status: true},
		{name: 'Timed redirection', status: false},
		{name: 'Visitor registration', status: false},
		{name: 'Reporting', status: true},
		{name: 'Office 365 calendar sync', status: false},
		{name: 'Teams presence', status: true},
		{name: 'Teams federation', status: false},
		{name: 'Google workspace catalog sync', status: false},
		{name: 'Google workspace calendar sync', status: false},
		{name: 'Webhooks', status: false},
		{name: 'Survey', status: true},
		{name: 'Webex sync', status: false},
		{name: 'Softphone', status: true},
		{name: 'Connect equipment control', status: false},
	], [data]);

	const renderItemServices = useCallback((item: BedriftsnettService, index: number) => (
		<Table.Row
			key={index}
			// onClick={() => onRowClick(item)}
			// selected={item.index === index}
			index={index}
		>
			<Table.Cell>{item?.name}</Table.Cell>
			<Table.Cell>
				<Layout justifyContent="center" fullWidth>
					<Checkbox big disabled toggle checked={item.status} />
				</Layout>
			</Table.Cell>
		</Table.Row>
	), []);

	return (
		<StyledSectionDiv
			style={{
				display: 'flex',
				flexDirection: 'row',
				flexGrow: '1',
				overflow: 'hidden',
				padding: '16px 8px'
			}}
			$endDiv
			$fullHeight
		>
			<Layout direction="column" nowrap style={{minWidth: '350px', overflow: 'hidden'}}>
				<Table
					items={services || []}
					renderItem={renderItemServices}
					variant="compact"
					rowHeight={25}
					fullWidth
				>
					<Table.Row>
						<Table.Cell>{t('Services')}</Table.Cell>
						<Table.Cell width={50}>{t('Status')}</Table.Cell>
					</Table.Row>
				</Table>
			</Layout>
			<Layout direction="column" nowrap fullWidth></Layout>
			<Layout direction="column" nowrap fullWidth></Layout>
		</StyledSectionDiv>
	);
}

export default BedriftsnettTable;
